import {Injectable} from '@angular/core';
import {GenericService} from "../../core/commons/generic.service";
import {QueryOptions} from "../../core/commons/query.options";
import {Dictamen} from "../domain/dictamen";
import {AuthService} from "../../core/security/auth.service";
import {Headers, RequestOptions, RequestMethod, Response, ResponseContentType} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {environment} from "environments/environment";

@Injectable()
export class DictamenService extends GenericService<Dictamen> {

    private resourcePath: string = "/dictamen";
    private uploadPath: string = "/upload";
    private downloadPath: string = "/file/";

    constructor(public authService : AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): Dictamen {
        return new Dictamen(value);
    }

    protected getResourcePath(): string {
        return this.resourcePath;
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public uploadPDF(file: File, name: string): Observable<any>{

        let formData:FormData = new FormData();
        formData.append('file', file, name);
        const headers = new Headers({});
        headers.set("Authorization", localStorage.getItem(environment.tokenName));
        let options = new RequestOptions({ headers });

        return this.authService.http.post(this.baseUrl+this.resourcePath+this.uploadPath, formData, options)
            .map(res => res.json());
    }

    public downloadPDF(fileID: string): Observable<any> {
        const headers = new Headers({});
        headers.set("Authorization", localStorage.getItem(environment.tokenName));
        let options = new RequestOptions({ headers: headers, responseType : ResponseContentType.Blob});
        return this.authService.http.get(this.baseUrl+this.resourcePath+this.downloadPath+fileID, options)
            .map( res => {
                return new Blob([res.blob()], { type: 'application/pdf' });
            });
    }

}











// WEBPACK FOOTER //
// ./src/app/fiscalia/service/dictamen.service.ts